// src/services/api/leadAutomation.js
import { apiClient } from './base';

// ── Google OAuth ──────────────────────────────────────────────────────────────

export const getGoogleConnectionStatus = async () => {
  try {
    const response = await apiClient.get('/google/status');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getGoogleAuthUrl = async () => {
  try {
    // Pass current frontend origin + path so the backend redirects back here
    // regardless of whether it's dev (localhost) or production.
    const returnTo = `${window.location.origin}/lead-automation`;
    const response = await apiClient.get('/google/auth-url', { params: { returnTo } });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const disconnectGoogle = async () => {
  try {
    const response = await apiClient.delete('/google/disconnect');
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ── Lead Forms CRUD ───────────────────────────────────────────────────────────

export const getLeadForms = async () => {
  try {
    const response = await apiClient.get('/meta-lead-forms');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLeadFormById = async (id) => {
  try {
    const response = await apiClient.get(`/meta-lead-forms/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createLeadForm = async (data) => {
  try {
    const response = await apiClient.post('/meta-lead-forms', data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateLeadForm = async (id, data) => {
  try {
    const response = await apiClient.put(`/meta-lead-forms/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteLeadForm = async (id) => {
  try {
    const response = await apiClient.delete(`/meta-lead-forms/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ── Sheet column discovery ────────────────────────────────────────────────────

export const getSheetColumns = async ({ sheetId, tabName }) => {
  try {
    const response = await apiClient.get('/meta-lead-forms/sheet-columns', {
      params: { sheetId, tabName },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ── Upload ────────────────────────────────────────────────────────────────────

export const triggerUpload = async (id) => {
  try {
    const response = await apiClient.post(`/meta-lead-forms/${id}/upload`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ── Session history ───────────────────────────────────────────────────────────

export const getUploadSessions = async (id, params = {}) => {
  try {
    const response = await apiClient.get(`/meta-lead-forms/${id}/sessions`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ── Cursor reset ──────────────────────────────────────────────────────────────

export const resetCursor = async (id) => {
  try {
    const response = await apiClient.post(`/meta-lead-forms/${id}/reset-cursor`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
